import axios from 'axios'

// 创建axios实例
const ajax = axios.create({
  baseURL: '',
  timeout: 100 * 1000, // 请求超时时间 100s
  withCredentials: true, // 允许跨域传递 cookie
})

// request拦截器
ajax.interceptors.request.use(
  config => {
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response 拦截器
ajax.interceptors.response.use(
  response => {
    return Promise.resolve(response.data)
  },
  error => {
    return Promise.reject(error.message || '服务器开小差')
  }
)

export default ajax